export const addScript = src => {
  const script = document.createElement('script')
  script.defer = true
  script.src = src
  window.document.body.appendChild(script)
}

export const getQueryParamValue = param => {
  const regex = new RegExp(`[?&]${param}(=([^&#]*)|&|#|$)`, 'i')
  const results = regex.exec(window.location.href)

  if (!results)
    return null

  return results[2]
    ? decodeURIComponent(results[2].replace(/\+/g, ' '))
    : null
}